// extracted by mini-css-extract-plugin
module.exports = {"more":"SecondaryList-SecondaryList-more-7d1e337a"};